import { type FunctionComponent } from "react"
import { Spinner } from "design-kit"
import { css } from "@emotion/react"

const Loader: FunctionComponent = () => (
  <div
    css={css`
      min-height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;

      // Only appear after a short delay so that user on fast connections don't
      // see the spinner flash in and out
      @keyframes appear {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }

      opacity: 0;
      animation-name: appear;
      animation-delay: 0.5s;
      animation-fill-mode: forwards;
    `}
  >
    <Spinner />
  </div>
)

export default Loader
